import { MotionValue, m } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { createPortal } from 'react-dom';

const DragBar = ({ y, offsetY = 0, zIndex = 102, mountTo, delay = 300 }: { y?: MotionValue<number>; offsetY?: number; zIndex?: number; mountTo?: HTMLElement; delay?: number }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  useEffect(() => {
    if (!isVisible || !ref.current) return;
    const container = ref.current.closest('.scroll-container');
    if (!container) return;
    setContainerRef(container as HTMLDivElement);
  }, [isVisible, containerRef]);

  const content = (
    <m.div
      ref={ref}
      data-component="DragBar"
      className="fixed left-1/2 mb-4 h-2 w-12 -translate-x-1/2 rounded-full"
      style={{ x: '-50%', y, top: `calc(${offsetY}px + 1rem)`, zIndex, backgroundColor: 'var(--bcs-semantic-dialog-bg-handle)' }}
    />
  );

  if (!isVisible) return null;

  if (containerRef) {
    return createPortal(content, mountTo ?? document.getElementById('hMainContainer') ?? document.body);
  }

  return content;
};

export default DragBar;
